const API_References =  "/BDA/References"
const API_Foods =  "/BDA/Foods"
const API_SearchFoodByName =  "/BDA/SearchFoodByName"
const API_SearchFoodByCode =  "/BDA/SearchFoodByCode"
const API_SearchFoodByCategory =  "/BDA/SearchFoodByCategory"
const API_SearchFoodAdvanced =  "/BDA/SearchFoodAdvanced"
const API_FoodCategories =  "/BDA/FoodCategories"
const API_FoodCategoriesSearch =  "/BDA/FoodCategoriesSearch"
const API_SummaryComponents =  "/BDA/SummaryComponents"
const API_FoodComponents =  "/BDA/FoodComponents"
const API_Components =  "/BDA/Components"
const API_FoodInfo =  "/BDA/FoodInfo"
const API_Strings = "/BDALocalization/Strings"
const TITOLO_APP = "Banca Dati Alimentare";
const DEF_LANG = "ita";


export default {
    APIReferences: API_References,
    APIFoods: API_Foods,
    APISearchFoodByName: API_SearchFoodByName,    
    APISearchFoodByCode:API_SearchFoodByCode,
    APISearchFoodByCategory:API_SearchFoodByCategory,
    APISearchFoodAdvanced:API_SearchFoodAdvanced,
    APIFoodCategories:API_FoodCategories,
    APIFoodCategoriesSearch:API_FoodCategoriesSearch,
    APISummaryComponents:API_SummaryComponents,
    APIFoodComponents:API_FoodComponents,
    APIComponents:API_Components,
    APIFoodInfo:API_FoodInfo,
    APISTRINGS: API_Strings,
    TITOLOAPP: TITOLO_APP,
    DEFLANG: DEF_LANG
}